import React from "react";
import { Icon } from "@iconify/react";
import iconoWhatsapp from "@iconify/icons-mdi/whatsapp";
import stylebtn from "../styles/btn.module.scss";

// Botón "Enviar por WhatsApp" para los documentos PDF (factura, cotización,
// alquiler). onClick llama a una función de helpers/compartirDocumentoWhatsApp
const BotonWhatsappPdfComponent = ({ onClick, disabled = false, styleGroup = "" }) => {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={`${stylebtn.btn} ${stylebtn.whatsapp} ${styleGroup}`}
        >
            <Icon icon={iconoWhatsapp} aria-hidden="true" /> ENVIAR POR WHATSAPP
        </button>
    );
};

export default BotonWhatsappPdfComponent;
